// extracted by mini-css-extract-plugin
export default {"font-renta":"PhasesPage_font-renta__Quxt2","phases":"PhasesPage_phases__XFUGw","grid":"PhasesPage_grid__u0bJ8"};